const state = {
  USERINFO: null,
  TOKEN: undefined,
  MENUS: [],
  SPLICING_URL: "http://allin.zxdev.top",
};

export default state;
